/**
 * CLEARO in-view helper
 *
 * Any element with [data-clr-inview] gets:
 *   .is-armed  — as soon as this script runs (so without JS, content is simply visible)
 *   .is-inview — once ~25% of it has scrolled into view (one time only)
 * Sections style their entrance animations off these two classes.
 */
(() => {
  if (window.clearoInview) return;
  window.clearoInview = true;

  const SELECTOR = '[data-clr-inview]:not(.is-armed)';

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-inview');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.25 }
        )
      : null;

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (!observer) {
        el.classList.add('is-armed', 'is-inview');
        return;
      }
      el.classList.add('is-armed');
      observer.observe(el);
    });
  };

  init();

  // Re-initialise sections re-rendered in the theme editor
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
